/*
  Page produit, version desktop : pastilles de pagination et navigation au
  clic sur les moities de l'image.

  En desktop la galerie de Dawn n'est pas un carrousel : un seul media porte
  la classe is-active, les autres sont retires de l'affichage, et ce sont les
  vignettes qui font le changement. Les pastilles et les moities relaient donc
  le clic vers la vignette correspondante plutot que de faire defiler quoi que
  ce soit : toute la logique de Dawn — media actif, vignette courante, arret
  des videos — reste seule maitresse.
*/
(() => {
  const DESKTOP = '(min-width: 990px)';


  const setup = (gallery) => {
    if (gallery.dataset.pdpArrows === 'done') return;

    const thumbs = [...gallery.querySelectorAll('.thumbnail-list__item')];
    const dots = [...gallery.querySelectorAll('.product__media-dot')];
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || thumbs.length < 2) return;

    gallery.dataset.pdpArrows = 'done';

    const go = (index) => {
      const target = thumbs[(index + thumbs.length) % thumbs.length];
      const button = target && target.querySelector('button');
      if (button) button.click();
    };

    const currentIndex = () => {
      const active = viewer.querySelector('[data-media-id].is-active');
      if (!active) return 0;
      const found = thumbs.findIndex((t) => t.dataset.target === active.dataset.mediaId);
      return found === -1 ? 0 : found;
    };

    // Pastilles : deja dans le balisage, posees pour le balayage mobile.
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => go(i));
    });

    /*
      Moities de l'image : pas de fleche posee dessus, le curseur suffit a dire
      ou mene le clic. Deux couches transparentes portent ce curseur, faute de
      pouvoir le faire varier a l'interieur d'un meme element.
    */
    const zones = [
      { cls: 'prev', label: 'Previous image', step: -1 },
      { cls: 'next', label: 'Next image', step: 1 },
    ].map(({ cls, label, step }) => {
      const zone = document.createElement('div');
      zone.className = `pdp-gallery-half pdp-gallery-half--${cls}`;
      zone.setAttribute('aria-hidden', 'true');
      zone.title = label;
      zone.addEventListener('click', () => go(currentIndex() + step));
      gallery.appendChild(zone);
      return zone;
    });

    /*
      Moities de l'image : la gauche revient en arriere, la droite avance.
      Le clic est ecoute sur le conteneur du media et non sur l'image, pour
      couvrir toute la surface affichee. Les pastilles et la pastille de marque
      gardent leur propre clic.
    */
    const viewerClickable = viewer.querySelector('.product__media-list') || viewer;
    viewerClickable.addEventListener('click', (event) => {
      if (event.target.closest('.product__media-dots, .product__vendor-pill, a, button')) return;
      const rect = viewerClickable.getBoundingClientRect();
      if (!rect.width) return;
      go(currentIndex() + (event.clientX - rect.left < rect.width / 2 ? -1 : 1));
    });

    /*
      Le media actif change par la vignette, par une variante ou par le clavier :
      on observe la classe plutot que de tenir un compteur, qui se desynchroniserait.
    */
    const sync = () => {
      const index = currentIndex();
      dots.forEach((dot, i) => dot.classList.toggle('product__media-dot--active', i === index));
    };

    new MutationObserver(sync).observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    sync();
    return zones;
  };

  const run = () => {
    if (!window.matchMedia(DESKTOP).matches) return;
    if (!document.querySelector('#MainContent.pdp-flow')) return;
    document.querySelectorAll('#MainContent.pdp-flow media-gallery').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Changement de variante : Shopify remplace la section, la galerie est neuve.
  document.addEventListener('shopify:section:load', run);
  window.matchMedia(DESKTOP).addEventListener('change', run);
  window.addEventListener('pageshow', run);
})();
